import React from 'react';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import styled from '@emotion/styled';
import { labelTextStyle, linkStyle } from './MegaMenu.styles';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { css } from '@emotion/react';
import Link, { LinkVariants } from '@polestar/component-warehouse-react/components/link/Link';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import { visuallyHiddenStyles } from '@polestar/component-warehouse-react/components/hidden-accessibility-element/HiddenAccessibilityElement';
export const MegaMenuLink = ({ href, label, tabIndex, onKeyDown, onFocus, size = Sizes.large, external, openExternalLink, ...props }) => {
    return (React.createElement(StyledLink, { ...props, variant: LinkVariants.navigation, href: href, ...aria({
            label: `${props['aria-label']}${openExternalLink && external ? ` ${openExternalLink}` : ''}`,
        }), tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, small: size === Sizes.small, ...(external ? { target: '_blank', rel: 'noreferrer' } : {}) },
        label,
        external && openExternalLink && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement(HiddenNewWindowText, null, openExternalLink)))));
};
// TODO: needs to be TextAnchorButton due to hitArea?
// I think padding is big enough that hit area isn't needed /Linn
const StyledLink = styled(Link)(({ small }) => css(css `
      ${linkStyle};
      text-decoration: none;
      padding-block: ${createCustomSpacing(5 / 16)};
    `, !small &&
    css `
        @media (pointer: coarse) {
          padding: ${createCustomSpacing(5 / 16)} 0;
        }
      `, small &&
    css `
        ${labelTextStyle};
        padding-block: ${createCustomSpacing(11 / 16)};
      `));
const HiddenNewWindowText = styled.span `
  ${visuallyHiddenStyles};
`;
